import React, { useEffect, useState, useCallback } from "react";
import {
  // useSearchParams,
  useLocation,
} from "react-router-dom";
import styles from "./FindExpert.module.css";

import WhyimporcMentor from "../../components/Whyimporc/WhyimporcMentor";
import WhyimporcAuthor from "../../components/Whyimporc/WhyimporcAuthor";
// import HowItWorks from "../../components/HowItWorks/HowItWorks";
// import Assured from "../../components/Assured/Assured";
import FrequentAskQuestion from "../../components/FrequentAskQuestion/FrequentAskQuestion";
import FiltersMentor from "./Filters/FiltersMentor";
import FiltersAuthor from "./Filters/FiltersAuthor";

import Banner from "../../components/FindExpert/Banner";
// import TestimonialSlider from "../../components/Testimonial/TestimonialSlider";
import ProfileList from "../../components/FindExpert/ProfileList";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import Pagination from "../../components/Pagination/Pagination";
import { API_ENDPOINTS } from "../../api/endpoints";
import apiClient from "../../api/apiClient";
import { useMentorship } from "../../hooks/useMentorship";
import { useGetSubjectExpertiseQuery } from "../../api/apiSlice";

const FindExpert = () => {
  const { pathname } = useLocation();
  const role = pathname.includes("mentors") ? "mentor" : "author";

  const [mentorList, setMentorList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const { data: subjectExpertiseRes } = useGetSubjectExpertiseQuery(undefined, {
    skip: role !== "mentor",
  });
  const { mentorshipOffered } = useMentorship();

  const subjectExpertise =
    role === "mentor" ? subjectExpertiseRes?.data ?? [] : [];

  const [filters, setFilters] = useState({
    searchExpert: ""
  });

  const [page, setPage] = useState(1);
  const [pageSize] = useState(5);
  const [totalPages, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  /* -------------------- API CALLER -------------------- */
  const fetchExperts = useCallback(async () => {
    try {
      setLoading(true);
      setApiError(null);

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", pageSize);

      if (filters.searchExpert)
        params.append("searchExpert", filters.searchExpert);
      if (filters.regions && filters.regions.length)
        params.append("country", filters.regions.join(","));
      if (filters.subjects && filters.subjects.length)
        params.append("subjects", filters.subjects.join(","));

      if (filters.services && filters.services.length)
        params.append("services", filters.services.join(","));
      if (filters.more && filters.more.length) params.append("more", filters.more.join(","));

      if (filters.hasPublications) params.append("hasPublications", "true");
      if (filters.hasPhd) params.append("hasPhd", "true");
      if (filters.highestQualification && filters.highestQualification.length)
        params.append("highestQualification", filters.highestQualification.join(","));
      if (filters.academicStanding && filters.academicStanding.length)
        params.append("academicStanding", filters.academicStanding.join(","));
      if (filters.experienceLevel && filters.experienceLevel.length)
        params.append("experienceLevel", filters.experienceLevel.join(","));
      if (filters.phdFilters && filters.phdFilters.length)
        params.append("phdFilters", filters.phdFilters.join(","));
      if (filters.researchExperience && filters.researchExperience.length)
        params.append("researchExperience", filters.researchExperience.join(","));

      const url =
        role === "mentor"
          ? `${API_ENDPOINTS.GET_MENTORS_LIST}?${params.toString()}`
          : `${API_ENDPOINTS.GET_AUTHORS_LIST}?${params.toString()}`;

      const res = await apiClient({ url, method: "get", withAuth: true });

      if (role === "mentor") {
        setMentorList(res.data.mentors.data || []);
        setTotalRecords(res.data.mentors.total);
        setTotalPage(Math.ceil(res.data.mentors.total / pageSize));
      } else {
        setAuthorList(res.data.authors.data || []);
        setTotalRecords(res.data.authors.total);
        setTotalPage(Math.ceil(res.data.authors.total / pageSize));
      }
    } catch (error) {
      setApiError(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }, [filters, page, pageSize, role]);

  /* -------------------- FETCH LIST (ONLY HERE) -------------------- */
  useEffect(() => {
    fetchExperts();
  }, [fetchExperts]);

  /* -------------------- ROLE CHANGE HANDLER -------------------- */
  useEffect(() => {
    setPage(1);
    setFilters((prev) => ({ ...prev, searchExpert: "" }));
  }, [role]);

  /* -------------------- FILTER HANDLER -------------------- */
  const handleFilterChange = (newFilters) => {
    setPage(1);
    setFilters(newFilters);
  };

  /* -------------------- SEARCH HANDLER (ICON CLICK) -------------------- */
  const handleSearch = (value) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, searchExpert: value }));
  };

  return (
    <main className={styles.findExpertPage}>
      <Banner
        userType={role === "mentor" ? "Mentors" : "Authors"}
        searchValue={filters.searchExpert}
        onSearch={handleSearch}
      />

      {role === "mentor" && (
        <FiltersMentor 
          onFilterChange={handleFilterChange} 
          currentFilters={filters} 
        />
      )}
      {role === "author" && (
        <FiltersAuthor onFilterChange={handleFilterChange} currentFilters={filters} />
      )}
      <div className={styles.container}>
        <div className={styles.mainContainer}>
          <div className={styles.leftSection}>
            <div className={styles.showing}>
              <strong>Showing {totalRecords}</strong>{" "}
              {role === "mentor" ? "Mentors" : "Authors"}
            </div>

            {loading ? (
              <Loader fullscreen />
            ) : apiError ? (
              <ErrorMsg message={apiError} />
            ) : role === "mentor" ? (
              mentorList.length ? (
                <ProfileList
                  data={mentorList}
                  user="mentors"
                  role="mentor"
                  subjectExpertise={subjectExpertise}
                  mentorshipOffered={mentorshipOffered}
                />
              ) : (
                <p className={styles.noRecords}>No mentors found.</p>
              )
            ) : authorList.length ? (
              <ProfileList data={authorList} user="authors" role="author" />
            ) : (
              <p className={styles.noRecords}>No authors found.</p>
            )}

            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </div>

          <div className={styles.rightSection}>
            {/* <div className={styles.marginBottom}>
            <Assured />
            </div> */}
            <div className={styles.marginBottom}>
              <FrequentAskQuestion role={role} />
            </div>
            {/* <div className={styles.marginBottom}>
            <TestimonialSlider />
            </div> */}
            <div className={styles.marginBottom}>
              {role === "mentor" ? <WhyimporcMentor /> : <WhyimporcAuthor />}
            </div>

            {/* <div className={styles.marginBottom}>
            <HowItWorks />
            </div> */}
          </div>
        </div>
      </div>
    </main>
  );
};

export default FindExpert;
